import { FC, ReactNode } from 'react';
import { TranslateFn } from 'hooks/useTranslate';
import { envelopeStatus } from 'modules/envelopes/components/EnvelopesTable/envelopeStatus';

type EnvelopeBadgesProps = {
  children: ReactNode;
};

type StatusProps = {
  t: TranslateFn;
  style: string;
  text: string;
  status: keyof typeof envelopeStatus;
};

const badgeClass = 'badge badge-pill badge-sm';

const EnvelopeBadges: FC<EnvelopeBadgesProps> & {
  Status?: FC<StatusProps>;
} = ({ children }) => <>{children}</>;

EnvelopeBadges.Status = ({ t, style, text, status }) => {
  const statusIcon = envelopeStatus[status as keyof typeof envelopeStatus].icon;

  return (
    <span className={`${badgeClass} ${style}`}>
      <em className={`icon mr-1 ni ${statusIcon}`} />
      {text ? t(text) : ''}
    </span>
  );
};

EnvelopeBadges.displayName = 'EnvelopeBadges';

EnvelopeBadges.Status.displayName = 'Status';

export default EnvelopeBadges;
